export const normalizeTextString = (
  inputString: string,
  trimWhitespace = false,
) => {
  let returnString = '';
  if (inputString) {
    returnString =
      inputString
        .toLocaleLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') || '';
  }
  return trimWhitespace ? returnString.trim() : returnString;
};

export const normalizeLocale = (locale: string) => {
  const [language, region] = locale?.split('-');
  return region
    ? `${language.toLowerCase()}-${region.toUpperCase()}`
    : language.toLowerCase();
};
